import type { MouseEventHandler } from "react";
import { safeHref } from "./design";
import type { SiteDocument } from "./types";

export function ContactSocialLinks({ social, onNavigate }: { social: SiteDocument["social"]; onNavigate?: MouseEventHandler<HTMLAnchorElement> }) {
  const links = [["Facebook", social.facebook], ["Instagram", social.instagram], ["LinkedIn", social.linkedin], ["TikTok", social.tiktok], ["YouTube", social.youtube]].filter(([,url]) => Boolean(url));
  if (!links.length) return null;
  return <div className="contact-social-links">{links.map(([label,url]) => <a key={label} href={safeHref(url)} target="_blank" rel="noopener noreferrer" onClick={onNavigate}>{label}<span aria-hidden="true"> ↗</span></a>)}</div>;
}
